// SAT V4 Zone - Main Zone Component
import { DsIcon } from '@ice-web-app/designSystem';
import { loadModuleNamespace } from '@ice-web-app/shared-i18n';
import { useGlobalStore, useSidebarStore } from '@ice-web-app/shared-store';
import { getCurrentEcosystemBasePath } from '@ice-web-app/shared-utils';
import { type FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sat4AR, sat4DE, sat4EN } from '../locales';
import { ZoneRoutes } from '../routes/ZoneRoutes';
import { routes } from '../routes/routes';

export const SatV4Zone: FC = () => {
  const { setMenuItems, setEntityMenuItems, setShowEntityMenu, setBackPath } = useSidebarStore();
  const { setShowMainSidebar } = useGlobalStore();
  const showMainSidebar = localStorage.getItem('showMainSidebar') === 'true';
  const location = useLocation();

  useEffect(() => {
    setShowMainSidebar(showMainSidebar);
  }, [showMainSidebar, setShowMainSidebar]);

  // Check if we are on a detail/entity route
  useEffect(() => {
    const isTeacherDetail = location.pathname.includes('/user-management/teacher/');
    const isPupilDetail = location.pathname.includes('/user-management/pupil/');

    if (isTeacherDetail || isPupilDetail) {
      setShowEntityMenu(true);
      setEntityMenuItems([]);
    } else {
      setShowEntityMenu(false);
      setEntityMenuItems([]);
    }
  }, [location.pathname, setShowEntityMenu, setEntityMenuItems]);

  useEffect(() => {
    setBackPath(getCurrentEcosystemBasePath() || '/');

    setMenuItems([
      {
        title: 'Dashboard',
        icon: <DsIcon icon="HOME" />,
        path: routes.dashboard,
      },
      {
        title: 'Upload',
        icon: <DsIcon icon="UPLOAD" />,
        path: routes.upload,
      },
      {
        title: 'School Structure',
        icon: <DsIcon icon="SCHOOL_STAFF" />,
        path: routes.schoolStructure,
      },
      {
        title: 'User Management',
        icon: <DsIcon icon="PROFILE" />,
        path: routes.userManagement.base,
      },
      {
        title: 'Rules & Preferences',
        icon: <DsIcon icon="SETTING_COG" />,
        path: routes.rulesPreferences,
      },
      {
        title: 'Timetable Management',
        icon: <DsIcon icon="CALENDAR" />,
        path: routes.timetable.createTimetable,
        submenu: [
          { title: 'Create Timetable', path: routes.timetable.createTimetable, icon: <DsIcon icon="CALENDAR" /> },
          { title: 'Timetable Views', path: routes.timetable.userViews },
          { title: 'Subject Options', path: routes.timetable.subjectOptions },
        ],
      },
      {
        title: 'Settings',
        icon: <DsIcon icon="SETTING" />,
        path: routes.settings,
      },
      {
        title: 'Analytics',
        icon: <DsIcon icon="ANALYTICS" />,
        path: routes.timetable.analytics
      }
    ]);

    return () => {
      setBackPath('');
    };
  }, [setMenuItems, setBackPath]);

  useEffect(() => {
    loadModuleNamespace('satV4Zone', [
      { jsonFile: sat4AR, lang: 'ar' },
      { jsonFile: sat4DE, lang: 'de' },
      { jsonFile: sat4EN, lang: 'en' },
    ]);
  }, []);

  return <ZoneRoutes />;
};

export default SatV4Zone;
